/** The two asset folders of the social platform logos: 24x24 and 80x80 png. */
export type SocialLogoSize = 'small' | 'medium';

/**
 * The asset path of a platform logo served by its file name (nom_content_platform, SEN-6208 slice 1c);
 * null when the platform has no asset yet, so the caller renders the name alone.
 */
export function socialLogoPath(
  size: SocialLogoSize,
  file: string | null | undefined,
): string | null {
  return file ? `assets/img/social/logo-${size}/${file}` : null;
}
